module.exports = __webpack_public_path__ + "img/sec17desk.fbb64713.png";